import React from 'react';
import {Video, Formatted} from 'components';
import {config} from 'helpers';

export function PassionGoDeeper() {
  return (
    <div>
      <Formatted className="medium-spacing">
        <Video.Video src={config.videos.identity.passion2} />
        <p>Connecting with your passionate self will come easily to some, but may not be as simple for others. This exercise is designed to acquaint yourself with that passionate side you know is there. First, rate yourself on a passion scale of 1 to 10 (1 least, 10 most). How much does your passion show up in your life? Ask two people who know you well how they would rate you.</p>
        <p>Then, consider what it would be like if you became a 9 or a 10. What would that look like? What would it feel like? Do you like that picture? What can you do today to engage more with your passionate side? Do you commit to doing that?</p>
      </Formatted>
    </div>
  );
}
